import * as React from "react";
const SVGComponent = ({ color = "#5989E1", ...props }) => (
  <svg
    width={props?.width || 23}
    height={props?.height || 23}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx={10.3335}
      cy={10}
      r={8}
      fill="white"
      stroke={color}
      strokeWidth={2}
    />
  </svg>
);
export default SVGComponent;